import { useEffect } from 'react';
import { chartToPptDataForCollections, getPageTitle, getTabTitle } from '../../export/utils/chartToPptData';
import { InsightCollection } from '../../content/collection/types';
import { ComponentHeading, DataColumn, PageDsl, Params } from '../../types';
import { getComponentTitle } from '../../export/utils/componentToPptData';
import { mapKeyIndicatorsForExport } from '../../export/utils/pptUtils';

export const useOnCollectionExportReady = ({
  collection,
  dsl,
  chartSliceRefs,
  componentName,
  componentSettings,
  allColumns,
  componentHeadingTitle,
  isDataLoading = false,
  //NEWE-50703: refLength is to get the updated length of the chartSliceRefs.current to trigger the useEffect when the chartSliceRefs.current is updated
  refLength,
}: {
  collection: InsightCollection;
  dsl: PageDsl;
  chartSliceRefs: React.MutableRefObject<HTMLDivElement | HTMLDivElement[]>;
  componentName?: string;
  componentSettings?: Params;
  allColumns?: DataColumn[];
  componentHeadingTitle?: ComponentHeading['title'];
  isDataLoading?: boolean;
  refLength?: number;
}): void => {
  let chartElementsLength = 0;
  if (Array.isArray(chartSliceRefs.current)) {
    chartElementsLength = chartSliceRefs.current.length;
  } else if (chartSliceRefs.current) {
    chartElementsLength = 1;
  }

  useEffect(() => {
    const isComponentReady = chartElementsLength || componentName;
    if (!collection || !dsl || isDataLoading || !isComponentReady) {
      return;
    }

    let subtitle = '';
    if (componentHeadingTitle && allColumns.length && componentSettings) {
      subtitle = getComponentTitle(componentHeadingTitle, componentSettings, allColumns);
    } else {
      const pageTitle = getPageTitle(dsl) || '';
      const tabTitle = getTabTitle(dsl) || '';

      subtitle = [pageTitle, tabTitle].filter(Boolean).join(' - ');
    }
    const exportPng = async () => {
      if (componentName) {
        const exportContainer = document.querySelector(`#${componentName}_export_content`);
        let slidesContainerSelector = '';
        if (exportContainer.classList.contains('inline-flex')) {
          slidesContainerSelector = `#${componentName}_export_content`;
        } else {
          slidesContainerSelector = `.${componentName}-export-slide`;
        }
        let exportSlides: Element[] = Array.from(document.querySelectorAll(slidesContainerSelector));

        if (componentName.includes('overviewKeyIndicators')) {
          exportSlides = mapKeyIndicatorsForExport(exportSlides);
        }

        exportSlides.forEach((slide, idx) => (chartSliceRefs.current[idx] = slide as HTMLDivElement));
      }

      return chartToPptDataForCollections(chartSliceRefs.current);
    };

    const timeoutId = setTimeout(() => {
      collection.onExportReady({ exportPng, subtitle });
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [dsl, JSON.stringify(collection), chartElementsLength, isDataLoading, refLength]);
};
